import { useQuery } from '@tanstack/react-query';
import boardFormats from '../../config/boardFormats';
import { getMyActiveTemplates } from '../../services/templates';
import { getBoolean, getRemoteConfig } from 'firebase/remote-config';

const formats = boardFormats.map((item) => ({
  value: item.id,
  label: item.name,
  isDisabled: false,
}));

function useGetTemplates(enabled) {
  const remoteConfig = getRemoteConfig();
  const isFeatureTemplatesEnabled = getBoolean(
    remoteConfig,
    'FEATURE_TEMPLATES'
  );

  return useQuery(
    ['templates', 'getMyActiveTemplates'],
    () => getMyActiveTemplates(),
    {
      enabled,
      retry: false,
      initialData: [],
      select(data) {
        if (!isFeatureTemplatesEnabled) {
          return formats;
        }

        const formattedTemplates = data.map((d) => ({
          isDisabled: false,
          label: d.name,
          value: d.id,
          type: 'Custom',
          columns: d.columns,
        }));
        return [
          {
            label: 'Custom Templates',
            options: formattedTemplates.filter((f) => f.columns.length > 0),
          },
          { label: 'Built-in', options: formats },
        ];
      },
    }
  );
}

export default useGetTemplates;
